<template>
  <div>
    <v-fab-transition>
      <v-btn
        v-bind="$attrs"
        class="scanner-btn"
        color="primary"
        dark
        @click="qrCodeReaderShow = true">
        <v-icon color="white">
          $vuetify.icons.qrCode
        </v-icon>
      </v-btn>
    </v-fab-transition>

    <v-dialog
      :value="qrCodeReaderShow"
      @click:outside="onClose">
      <v-card>
        <div
          v-if="qrCodeReaderShow"
          class="scanner-wrapper">
          <qrcode-stream
            @decode="onDecode"
            @init="onInit" />
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,

  data() {
    return {
      qrCodeReaderShow: false,
      result: '',
      error: '',
    };
  },

  watch: {
    error(val) {
      this.$alertError(val);
    },
  },

  methods: {
    onDecode(result) {
      this.result = result.replace(/\s/g, '');
      this.$emit('decode', result);
      this.qrCodeReaderShow = false;
    },

    async onInit(promise) {
      try {
        await promise;
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.error = this.$vuetify.lang.t('$vuetify.messages.cameraNotAllowedError');
        } else if (error.name === 'NotFoundError') {
          this.error = this.$vuetify.lang.t('$vuetify.messages.cameraNotFoundError');
        } else if (error.name === 'NotReadableError') {
          this.error = this.$vuetify.lang.t('$vuetify.messages.cameraNotReadableError');
        } else if (error.name === 'OverconstrainedError') {
          this.error = this.$vuetify.lang.t('$vuetify.messages.cameraOverconstrainedError');
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.error = this.$vuetify.lang.t('$vuetify.messages.cameraStreamApiNotSupportedError');
        }
      }
    },

    onClose() {
      this.result = null;
      this.qrCodeReaderShow = false;
    },
  },
};
</script>

<style>
.scanner-wrapper {
  height: 450px;
  padding: 15px;
}
</style>
